var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-transfer',{staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"filterable":"","titles":[
      _vm.$l('label_userlist') || '待选用户列表',
      _vm.$l('label_selecteduserlist') || '已选用户列表'
    ],"format":{
      noChecked: '${total}',
      hasChecked: '${checked}/${total}'
    },"props":{
      key: 'userCode',
      label: 'userFullName'
    },"data":_vm.userListData},on:{"change":_vm.handleChange},model:{value:(_vm.selectedUserListData),callback:function ($$v) {_vm.selectedUserListData=$$v},expression:"selectedUserListData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }